import * as PIXI from 'pixi.js';

class AxisContainer extends PIXI.Container {
  /**
   * @param type string {horizontal | vertical}
   */
  constructor(type, {x,y,w,h}) {
    super();

    this.type = type;
    this.color = 0xdea906;
    this.radius = 5;

    this.speed = 3.7;

    this.pos_x = x
    this.pos_y = y
    this.pos_w = w
    this.pos_h = h

    this.quantity = type === 'horizontal' ? 7 : 5
    this.gap = 200;
    this.init();
    this.createMask()
  }

  init() {
    this.dots = new PIXI.Graphics()
    for (let i=0; i<this.quantity; ++i) {
      this.dots.beginFill(this.color)
      const next = i * this.gap
      const {radius} = this
      this.type === 'horizontal' ?
        this.dots.drawPolygon([
          next, -radius,
          next + radius, 0,
          next, radius,
          next - radius, 0,
        ]) :
        this.dots.drawPolygon([
          -radius,next,
          0, next + radius,
          radius, next,
          0, next - radius,
        ])
      this.dots.endFill()
    }
    this.addChild(this.dots);
  }

  createMask() {
    const {dots, type} = this
    const m = new PIXI.Graphics()
    m.beginFill(0xffffff, 0.5)
    type === 'horizontal' ?
      m.drawRect(dots.x + 4, dots.y - dots.height, dots.width, dots.height*2) :
      m.drawRect(dots.x - dots.width, dots.y, dots.width*2, dots.height - this.gap - 42)
    m.endFill()
    this.addChild(m)
    this.dots.mask = m
  }

  update() {
    const {type, dots, speed, quantity, gap, pos_w} = this
    if (type === 'horizontal') {
      dots.x -= speed;
      if (dots.x < 0) {
        dots.x = gap
      }
    } else {
      dots.y += speed;
      if (dots.y > gap) {
        dots.y = 0
      }
    }
  }

  start() {
    this.delayID = setInterval(this.update.bind(this), 50)
  }

  stop() {
    clearInterval(this.delayID)
  }
}

export default AxisContainer;
